import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import moment from 'moment';
import { compose, withStateHandlers } from 'recompose';

import styles from '../timeplan.css';
import TimeplanDay from './TimeplanDay';
import TimeplanDayCopy from '../TimeplanDayCopy';

function SelectedDate({
  date,
  disabled,
  renderFooter,
  onChangeTimeplanUnits,
  selectedDates,
  timeplanUnits,
  isEditable,
  toggleEditable,
  ...props
}) {
  const boxClassName = !isEditable ? `btn ${styles.timeplanDayBtn}` : styles.timeplanDayBox;
  return (
    <div className="col-md-6 col-lg-4">
      <div
        className={boxClassName}
        onClick={!isEditable ? toggleEditable : undefined}
        role={!isEditable ? 'button' : undefined}
        tabIndex={!isEditable ? '0' : undefined}
        data-testid="dateBox"
      >
        <h5
          className={styles.timeplanDate2}
          onClick={isEditable ? toggleEditable : undefined}
          role={isEditable ? 'button' : undefined}
          tabIndex={isEditable ? '0' : undefined}
        >
          {moment(date).format('ddd D/M')}
        </h5>

        {timeplanUnits.size === 0 && (
          <span className="text-danger">Ingen tid är angiven</span>
        )}

        {isEditable && timeplanUnits.size > 0 && (
          <div className={styles.timeplanDayCopy2}>
            <TimeplanDayCopy
              disabled={disabled}
              date={date}
              selectedDates={selectedDates}
              timeplanUnits={timeplanUnits}
              onChangeTimeplanUnits={onChangeTimeplanUnits}
            />
          </div>
        )}

        <TimeplanDay
          isEditable={isEditable}
          disabled={disabled}
          date={date}
          timeplanUnits={timeplanUnits}
          onChangeTimeplanUnits={onChangeTimeplanUnits}
          {...props}
        />

        {renderFooter ? renderFooter(date) : null}
      </div>
    </div>
  );
}

SelectedDate.defaultProps = {
  renderFooter: undefined,
  selectedDates: new List(),
  TimeplanDayComponent: TimeplanDay,
};

SelectedDate.propTypes = {
  date: PropTypes.string.isRequired,
  isEditable: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  renderFooter: PropTypes.func,
  timeplanUnits: PropTypes.instanceOf(List).isRequired,
  selectedDates: PropTypes.instanceOf(List),
  onChangeTimeplanUnits: PropTypes.func.isRequired,
  toggleEditable: PropTypes.func.isRequired,
};

export default compose(
  withStateHandlers(({ timeplanUnits }) => ({ isEditable: timeplanUnits.size === 0 }), {
    toggleEditable: ({ isEditable }) => () => ({ isEditable: !isEditable }),
  }),
)(SelectedDate);
